import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface SEOSettings {
  siteName: string;
  siteDescription: string;
  siteDomain: string;
  ogImageUrl: string;
  twitterHandle: string;
  siteAuthor: string;
  isLoading: boolean;
}

const SEO_SETTINGS_QUERY_KEY = "seo-settings";

const DEFAULTS = {
  siteName: "PayStreem",
  siteDescription:
    "PayStreem is a revolutionary music sponsorship platform connecting artists with sponsors",
  siteDomain: "https://www.paystreem.com",
  ogImageUrl:
    "https://mcdfkrkgkwrddtwetfww.supabase.co/storage/v1/object/public/paystreem-uploads/og-image.png",
  twitterHandle: "@giant_beats",
  siteAuthor: "Giant Beats® Technologies",
};

export function useSEOSettings(): SEOSettings {
  const { data, isLoading } = useQuery({
    queryKey: [SEO_SETTINGS_QUERY_KEY],
    queryFn: async () => {
      const keys = [
        "site_name",
        "site_description",
        "site_domain",
        "og_image_url",
        "twitter_handle",
        "site_author",
      ];
      const results = await Promise.all(
        keys.map((key) =>
          supabase.rpc("get_app_text_setting", { setting_key: key }),
        ),
      );

      return {
        siteName: results[0].data || DEFAULTS.siteName,
        siteDescription: results[1].data || DEFAULTS.siteDescription,
        siteDomain: results[2].data || DEFAULTS.siteDomain,
        ogImageUrl: results[3].data || DEFAULTS.ogImageUrl,
        twitterHandle: results[4].data || DEFAULTS.twitterHandle,
        siteAuthor: results[5].data || DEFAULTS.siteAuthor,
      };
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    siteName: data?.siteName || DEFAULTS.siteName,
    siteDescription: data?.siteDescription || DEFAULTS.siteDescription,
    siteDomain: data?.siteDomain || DEFAULTS.siteDomain,
    ogImageUrl: data?.ogImageUrl || DEFAULTS.ogImageUrl,
    twitterHandle: data?.twitterHandle || DEFAULTS.twitterHandle,
    siteAuthor: data?.siteAuthor || DEFAULTS.siteAuthor,
    isLoading,
  };
}

export { SEO_SETTINGS_QUERY_KEY };
